function getUnixTime(serverDate:any){
    return (new Date(serverDate).getTime() / 1000).toFixed(0)
}

export default getUnixTime;